import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Container } from 'react-bootstrap'
import SweetAlert from "react-bootstrap-sweetalert";
import {Prompt} from 'react-router-dom';

class BasePage extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }

      render(){
  
          return (
            <div className='p-3'>
              <h1>{this.props.title}</h1>
              <Container fluid className="p-0">
                {this.props.children}
              </Container>
            </div>
            );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true,
          auth: state.auth
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
  
        })
      )(BasePage);